module.exports = __webpack_public_path__ + "static/img/Isaac-Heeney.1ca65c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac-Heeney.jpg
// module id = FKo7
// module chunks = 0